module.exports = __webpack_public_path__ + "static/media/user-fi.22dd0e01.svg";